"use client";

import { useEffect, useRef } from "react";
import { ArrowUpRight } from "lucide-react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Button } from "@/components/ui/button";
export default function Detailedcasestudy() {
  const sectionRef = useRef<HTMLElement | null>(null);
  const cards = [{
    id: "card-1",
    number: "01",
    category: "PROCESSAMENTO TÉRMICO",
    title: "Laminagem a Frio",
    description: "Melhore a qualidade do aço e a produção com bicos e cabeçotes para todas as etapas do processo de laminagem a frio.",
    image: {
      src: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-11-as-15.45.53.png?v=v4ouvmzn12",
      srcset: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-11-as-15.45.53.png?v=54779cferar-wvc-srcset",
      sizes: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-11-as-15.45.53.png?v=rcrzc53dqo-wvc-sizes",
      alt: "Sistema de arrefecimento de metal fundido em ambiente siderúrgico"
    }
  }, {
    id: "card-2",
    number: "02",
    category: "LAMINAGEM DE PRECISÃO",
    title: "Fabrico de Alumínio",
    description: "Otimize as suas operações de arrefecimento de cilindros, lubrificação e sopro/secagem com a nossa tecnologia de pulverização para laminadores de alumínio.",
    image: {
      src: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-11-as-15.46.17.png?v=53xrl8hfwzt",
      srcset: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-11-as-15.46.17.png?v=h1657j1wv79-wvc-srcset",
      sizes: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-11-as-15.46.17.png?v=pt7emqkksqf-wvc-sizes",
      alt: "Sistema de lubrificação de precisão em linha de laminagem de aço"
    }
  }, {
    id: "card-3",
    number: "03",
    category: "TRATAMENTO DE SUPERFÍCIE",
    title: "Fabrico de Metais",
    description: "Melhore a consistência do produto e a segurança dos trabalhadores com as nossas soluções para o fabrico e conformação de metais.",
    image: {
      src: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-11-as-15.48.29.png?v=c32jxizcaxs",
      srcset: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-11-as-15.48.29.png?v=dltap3rwabc-wvc-srcset",
      sizes: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-11-as-15.48.29.png?v=nt77is6y63s-wvc-sizes",
      alt: "Bicos de alta pressão para descalcificação e controlo de óxidos em aço"
    }
  }];
  useEffect(() => {
    if (!sectionRef.current) return;
    gsap.registerPlugin(ScrollTrigger);
    const ctx = gsap.context(() => {
      const mm = gsap.matchMedia();
      mm.add({
        reduce: "(prefers-reduced-motion: reduce)",
        motion: "(prefers-reduced-motion: no-preference)"
      }, context => {
        const conditions = context.conditions as {
          reduce: boolean;
          motion: boolean;
        };
        if (conditions?.reduce) {
          gsap.set("[data-reveal='intro'], [data-reveal='card']", {
            opacity: 1,
            y: 0,
            clearProps: "all"
          });
          return;
        }
        gsap.from("[data-reveal='intro']", {
          opacity: 0,
          y: 24,
          duration: 0.7,
          ease: "cubic-bezier(0.22,0.61,0.36,1)",
          stagger: 0.08,
          scrollTrigger: {
            trigger: sectionRef.current,
            start: "top 82%"
          }
        });
        gsap.from("[data-reveal='card']", {
          opacity: 0,
          y: 32,
          duration: 0.7,
          ease: "cubic-bezier(0.22,0.61,0.36,1)",
          stagger: 0.12,
          scrollTrigger: {
            trigger: "[data-grid='cards']",
            start: "top 85%"
          }
        });
      });
    }, sectionRef);
    return () => ctx.revert();
  }, []);
  return <section data-section-id="31406" ref={sectionRef} id="detailedcasestudy" data-nav="dark" className="bg-background text-foreground relative overflow-hidden" style={{
    paddingBlock: "clamp(96px, 12vh, 168px)"
  }}>
      <div className="mx-auto w-full max-w-[1360px]" style={{
      paddingInline: "clamp(20px, 4vw, 56px)"
    }}>
        {}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-6 items-end">
          

          <div className="lg:col-span-5 lg:text-right">
            
          </div>
        </div>

        {}
        <div data-grid="cards" className="mt-12 md:mt-16 grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {cards.map((card, i) => <div key={card.id} data-index={i} data-reveal="card" className="group bg-card border border-border rounded-3xl p-6 sm:p-8 flex flex-col justify-between shadow-sm hover:shadow-md hover:border-primary/40 transition-all duration-300">
              <div>
                {}
                <div className="aspect-[3/2] overflow-hidden rounded-xl bg-muted mb-6 sm:mb-8 relative">
                  <img src={card.image.src} data-wvc-srcset={card.image.srcset} data-wvc-sizes={card.image.sizes} alt={card.image.alt} loading="lazy" decoding="async" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
                </div>

                {}
                <div className="text-xs font-semibold tracking-wider text-muted-foreground uppercase mb-3">
                  {card.number} — {card.category}
                </div>

                {}
                <h3 className="text-xl sm:text-2xl font-bold text-foreground mb-3 leading-snug">
                  {card.title}
                </h3>

                {}
                <p className="text-muted-foreground text-sm sm:text-base leading-relaxed">
                  {card.description}
                </p>
              </div>
            </div>)}
        </div>

        {}
        <div className="mt-12 md:mt-16 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-6 pt-8 border-t border-border/60">
          <p className="text-muted-foreground text-sm sm:text-base max-w-xl">
            Soluções desenhadas à medida das especificações técnicas e operacionais das centrais siderúrgicas em Portugal.
          </p>
          <Button className="bg-primary text-primary-foreground hover:bg-primary/90 h-13 rounded-lg gap-3 pl-7 pr-2 shrink-0" style={{
          height: "52px"
        }}>
            <span className="text-sm font-medium">Consulte-nos</span>
            <span className="inline-flex h-8 w-8 items-center justify-center rounded-lg bg-background text-primary transition-transform duration-300 group-hover:-rotate-45" aria-hidden="true">
              <ArrowUpRight className="h-4 w-4" />
            </span>
          </Button>
        </div>
      </div>
    </section>;
}